"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectV2 = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("./styles");

var _ButtonV = require("../../atoms/ButtonV2");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _utils = require("../../../global-files/utils");

var _SelectItemV = require("../../atoms/SelectItemV2");

var _InputText = require("../../atoms/InputText");

var _jsxRuntime = require("react/jsx-runtime");

var SelectV2 = function SelectV2(props) {
  var _positions$positionDr;

  var items = props.items,
      initialSelectedItems = props.initialSelectedItems,
      triggerType = props.triggerType,
      selectButton = props.selectButton,
      defaultItem = props.defaultItem,
      inputSearch = props.inputSearch,
      maxWidthSelect = props.maxWidthSelect,
      maxWidthDropdown = props.maxWidthDropdown,
      maxHeightDropdown = props.maxHeightDropdown,
      maxWidthItems = props.maxWidthItems,
      alignmentItemsOverflow = props.alignmentItemsOverflow,
      typeSelectItems = props.typeSelectItems,
      multiple = props.multiple,
      borderType = props.borderType,
      classNameSelect = props.classNameSelect,
      classNameDropdown = props.classNameDropdown,
      positionDropdown = props.positionDropdown,
      onChange = props.onChange;
  var positions = {
    topStart: "top-start",
    topEnd: "top-end",
    topCenter: "top",
    rightStart: "right-start",
    rightEnd: "right-end",
    rightCenter: "right",
    bottomStart: "bottom-start",
    bottomEnd: "bottom-end",
    bottomCenter: "bottom",
    leftStart: "left-start",
    leftEnd: "left-end",
    leftCenter: "left"
  };

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1]; // { .. }


  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      customItems = _useState4[0],
      setCustomItems = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showDropdown = _useState6[0],
      setShowDropdown = _useState6[1];

  var _useState7 = (0, _react.useState)("Sin titulo"),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      labelSelect = _useState8[0],
      setLabelSelect = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      textInputSearch = _useState10[0],
      setTextInputSearch = _useState10[1];

  var refInputTextSearch = (0, _react.useRef)(); // cada que cambie la lista de items

  (0, _react.useEffect)(function () {
    if ((0, _utils.isArrayEmpty)(items) || !(0, _utils.isObject)(initialSelectedItems)) {
      setSelectedItems({});
      renderItems();
      renderLabelSelect();
      return;
    } // items iniciales seleccionados


    if (!multiple) {
      var values = Object.keys(initialSelectedItems);
      if (values.length) setSelectedItems((0, _defineProperty2.default)({}, values[0], null));else setSelectedItems({});
    } else {
      setSelectedItems(initialSelectedItems);
    }

    renderItems();
    renderLabelSelect();
  }, [items]); // cada que cambien los items seleccionados

  (0, _react.useEffect)(function () {
    if (!(0, _utils.isObject)(selectedItems)) return;
    renderItems();
    renderLabelSelect();
  }, [selectedItems]); // evento click de cada item de la lista

  var onClickItem = function onClickItem(isSelected, value) {
    var selectedItemsCopy = (0, _objectSpread2.default)({}, selectedItems);

    if (isSelected) {
      multiple ? selectedItemsCopy[value] = null : selectedItemsCopy = (0, _defineProperty2.default)({}, value, null);
    } else delete selectedItemsCopy[value];

    setSelectedItems(selectedItemsCopy);
    onChange && onChange(selectedItemsCopy);
  };

  var onClickSearch = function onClickSearch() {
    setTextInputSearch(textInputSearch.trim());
    (refInputTextSearch === null || refInputTextSearch === void 0 ? void 0 : refInputTextSearch.current) && refInputTextSearch.current.blur();
    renderItems(textInputSearch.trim());
  };

  var renderLabelSelect = function renderLabelSelect() {
    if (!(0, _utils.isObject)(selectedItems)) return;
    var selectedItemsCopy = Object.keys(selectedItems);

    if (selectedItemsCopy.length > 1) {
      setLabelSelect("Personalizado");
    } else if (selectedItemsCopy.length === 1) {
      var labelItem = undefined;

      var _iterator = (0, _createForOfIteratorHelper2.default)(items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.value === selectedItemsCopy[0]) {
            labelItem = item.label;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      !(0, _utils.isStringEmpty)(labelItem) ? setLabelSelect(labelItem) : setLabelSelect("Sin titulo");
    } else {
      if (!(0, _utils.isStringEmpty)(defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.label) && defaultItem !== null && defaultItem !== void 0 && defaultItem.showLabelInSelect) {
        setLabelSelect(defaultItem.label);
      } else if (!(0, _utils.isStringEmpty)(selectButton === null || selectButton === void 0 ? void 0 : selectButton.label)) {
        setLabelSelect(selectButton.label);
      } else {
        setLabelSelect("Sin titulo");
      }
    }
  };

  var renderItems = function renderItems() {
    var textSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    if ((0, _utils.isArrayEmpty)(items)) setCustomItems([]);
    setCustomItems(items.map(function (item, index) {
      if (!(0, _utils.isStringEmpty)(textSearch) && !item.label.trim().toLowerCase().includes(textSearch.trim().toLowerCase())) {
        return null;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectItemV.SelectItemV2, {
        label: item.label,
        value: item.value,
        checkbox: typeSelectItems === "checkbox" ? true : typeSelectItems === "marginCheckbox" ? false : undefined,
        selected: (0, _utils.isObject)(selectedItems) && selectedItems[item.value] !== undefined ? true : false,
        onClick: onClickItem
      }, classNameSelect + "_item" + index);
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ClickAwayListener, {
    onClickAway: function onClickAway(event) {
      if (triggerType !== "hover") setShowDropdown(false);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      className: !(0, _utils.isStringEmpty)(classNameSelect) ? classNameSelect : "",
      borderType: borderType,
      maxWidthSelect: maxWidthSelect,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
        placement: (_positions$positionDr = positions[positionDropdown]) !== null && _positions$positionDr !== void 0 ? _positions$positionDr : positions.bottomCenter,
        open: triggerType !== "hover" ? showDropdown : undefined,
        arrow: false,
        componentsProps: {
          tooltip: {
            className: "dropdownSelect" + ((0, _utils.isStringEmpty)(classNameDropdown) ? "" : " " + classNameDropdown)
          },
          popper: {
            disablePortal: true
          },
          transition: {
            timeout: 300
          }
        },
        TransitionComponent: _material.Fade,
        enterDelay: 100,
        followCursor: false,
        disableFocusListener: true,
        disableTouchListener: true,
        disableHoverListener: triggerType !== "hover" || (selectButton === null || selectButton === void 0 ? void 0 : selectButton.disabled),
        title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [inputSearch && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "container-inputSearch" + (!(0, _utils.isStringEmpty)(inputSearch === null || inputSearch === void 0 ? void 0 : inputSearch.className) ? " " + inputSearch.className : ""),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
              className: "buttonSearch",
              type: "gray",
              transparent: true,
              size: 14,
              icon: _freeSolidSvgIcons.faSearch,
              onClick: function onClick(event) {
                if ((0, _utils.isStringEmpty)(textInputSearch) && refInputTextSearch !== null && refInputTextSearch !== void 0 && refInputTextSearch.current) {
                  setTextInputSearch("");
                  refInputTextSearch.current.focus();
                } else {
                  onClickSearch();
                }
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputText.InputText, {
              className: "inputSearch",
              type: "black",
              transparent: true,
              size: 12,
              placeHolder: (0, _utils.isStringEmpty)(inputSearch === null || inputSearch === void 0 ? void 0 : inputSearch.defaultText) ? "Texto a buscar" : inputSearch.defaultText,
              text: textInputSearch,
              onChangeText: function onChangeText(newValue) {
                return setTextInputSearch(newValue);
              },
              onEnter: function onEnter(event) {
                return onClickSearch();
              },
              refInputText: refInputTextSearch
            })]
          }), defaultItem && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectItemV.SelectItemV2, {
            label: defaultItem.label,
            value: null,
            checkbox: defaultItem.itemType === "checkbox" ? true : defaultItem.itemType === "marginCheckbox" ? false : undefined,
            selected: (0, _utils.isObject)(selectedItems) && Object.keys(selectedItems).length ? false : true,
            onClick: function onClick(isSelected, value) {
              if ((0, _utils.isObject)(selectedItems) && Object.keys(selectedItems).length) {
                setSelectedItems({});
                onChange && onChange({});
              }
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container-items",
            children: customItems
          })]
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerSelect, {
          className: "container-buttonSelect",
          maxWidthDropdown: maxWidthDropdown,
          maxHeightDropdown: maxHeightDropdown,
          alignmentItemsOverflow: alignmentItemsOverflow,
          maxWidthItems: maxWidthItems,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
            className: "buttonSelect" + (!(0, _utils.isStringEmpty)(selectButton === null || selectButton === void 0 ? void 0 : selectButton.className) ? " " + selectButton.className : ""),
            disabled: selectButton === null || selectButton === void 0 ? void 0 : selectButton.disabled,
            type: selectButton === null || selectButton === void 0 ? void 0 : selectButton.type,
            transparent: selectButton === null || selectButton === void 0 ? void 0 : selectButton.transparent,
            label: labelSelect,
            size: selectButton === null || selectButton === void 0 ? void 0 : selectButton.size,
            icon: _freeSolidSvgIcons.faCaretDown,
            iconPosition: ["left", "right", "top", "bottom"].includes(selectButton === null || selectButton === void 0 ? void 0 : selectButton.iconPosition) ? selectButton.iconPosition : "right",
            onClick: function onClick(event) {
              if (triggerType !== "hover") setShowDropdown(function (prev) {
                return !prev;
              });
            }
          })
        })
      })
    })
  });
};

exports.SelectV2 = SelectV2;